export interface LoginAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any;
}

/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum LoginErrorCodeEnum {
  KsExpired = '500016',
  DeviceNotRegistered = '2019',
}
